import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Stack,
  Step,
  StepContent,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import { useSearchParams } from "react-router-dom";

import { formatDate } from "@/formatter";
import { now } from "@/lib/dateTime";
import { OpportunityStatus } from "@/models";

import { AddOpportunityFollowingDialog } from "./AddOpportunityFollowingDialog";

import type { Opportunity } from "@/models";

type OpportunityFollowingProps = {
  data: Opportunity;
  queryKey: string;
};

export function OpportunityFollowing({
  data,
  queryKey,
}: OpportunityFollowingProps) {
  const [searchParams, setSearchParams] = useSearchParams();

  const dialog = searchParams.get("dialog");

  function onCloseDialog() {
    searchParams.delete("dialog");
    setSearchParams(searchParams);
  }

  function openAddDialog() {
    searchParams.set("dialog", "following-add");
    setSearchParams(searchParams);
  }

  const addFollowingDialog = {
    open: dialog === "following-add",
    onClose: onCloseDialog,
    opportunityId: data.id.toString(),
    fetchKeys: [queryKey],
  };

  const { followings, status } = data;
  const isFollowingOpportunity = status === OpportunityStatus.Open;

  return (
    <Card sx={{ height: "max-content" }}>
      <CardHeader
        title="การติดตามผล"
        action={
          isFollowingOpportunity ? (
            <Button variant="contained" size="large" onClick={openAddDialog}>
              เพิ่มการติดตาม
            </Button>
          ) : (
            <></>
          )
        }
        sx={{ ".MuiCardHeader-action": { m: 0 } }}
      />
      <CardContent>
        <Divider sx={{ mb: 3 }} />
        <Stepper orientation="vertical">
          {followings.map(({ followAt, remark, createdAt }, index) => (
            <Step
              key={createdAt.toISO()}
              active
              completed={index !== 0 || !isFollowingOpportunity}
            >
              <StepLabel
                StepIconProps={{ icon: followings.length }}
                sx={{ gap: 2 }}
              >
                ติดตามครั้งที่ {followings.length - index}
              </StepLabel>
              <StepContent sx={{ pl: 4.5 }}>
                <Stack>
                  <Typography variant="caption" color="text.secondary">
                    วันที่บันทึก : {formatDate(createdAt)}
                  </Typography>
                  <Typography
                    variant="caption"
                    color={
                      isFollowingOpportunity && index === 0 && followAt <= now()
                        ? "primary.main"
                        : "text.secondary"
                    }
                    mb={1}
                  >
                    วันที่ติดตาม : {formatDate(followAt)}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    หมายเหตุ : {remark || "-"}
                  </Typography>
                </Stack>
              </StepContent>
            </Step>
          ))}
        </Stepper>
      </CardContent>
      <AddOpportunityFollowingDialog {...addFollowingDialog} />
    </Card>
  );
}
